import { render, staticRenderFns } from "./goDialogLabel.vue?vue&type=template&id=52da28b9"
import script from "./goDialogLabel.vue?vue&type=script&lang=js"
export * from "./goDialogLabel.vue?vue&type=script&lang=js"
import style0 from "./goDialogLabel.vue?vue&type=style&index=0&id=52da28b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports